import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { activityOptions } from '@/module/Nomen/Activity/model/ActivityModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

import { useSortedNomen } from '@feature/utils';

type ActivitySelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ActivitySelectControl<T extends FieldValues>(props: ActivitySelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(activityOptions.getAll());
  const options = useSortedNomen(data, 'DESC');

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={options}
      {...props}
    />
  );
}
